/* eslint-disable consistent-return */
import styled, { keyframes } from 'styled-components';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import { _ } from '_locales';
import { cts_secure } from '../../../app/cts';
import apis from '../../../app/apis';
import { LoadingSpinner } from '../../../components';
import { Button } from '../../Education/components';

const Confirmation = ({
  bpData, contactInfo, returnId, selectedDate, mainColor, setCurrentPage, addressDetails = ''
}) => {
  const { main_color } = mainColor;
  const [paymentStatus, setPaymentStatus] = useState('');
  const [loading, setLoading] = useState();
  const [error, setError] = useState();

  const onDone = () => {
    setCurrentPage(0);
  };
  const fetchData = async () => {
    if (returnId) {
      setLoading(true);
      try {
        const { data } = await cts_secure('get', apis.bpCheckPaymentStatus(returnId));
        setPaymentStatus(data);
        setLoading(false);
      } catch (error) {
        setLoading(false);
        setError(true);
      }
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  if (loading) {
    return <LoadingSpinner />;
  }

  if (!paymentStatus || (paymentStatus?.success && paymentStatus?.payment === 'success')) {
    return (
      <Container>
        {loading ? <LoadingSpinner /> : (
          <Wrapper>
            <TextHeader dangerouslySetInnerHTML={{
              __html: bpData?.bulk_pickup_config?.confirmation_message?.replace('%SELECTED_DATE%',
                moment(paymentStatus ? paymentStatus?.selected_date : selectedDate).utc().format('dddd, MMMM D'))
                .replace('%SELECTED_ADDRESS%', addressDetails.address)
            }}
            />
            <Text>
              {_('bulkPickup.an_email_sent_to')}
              {' '}
              <StyledText>
                {paymentStatus ? paymentStatus?.email : contactInfo?.email}
              </StyledText>
              .
            </Text>
            <ButtonWrapper>
              <Button
                mainColor={main_color || false}
                aria-label={'Proceed to Payment'}
                onClick={onDone}
                fontSize="16px"
                padding="12px 24px"
              >
                {_('recycleRight.done')}
              </Button>
            </ButtonWrapper>
          </Wrapper>
        )}
      </Container>
    );
  }

  if (error || !paymentStatus?.success) {
    return (
      <Wrapper>
        <ErrorMessage>Something went wrong!</ErrorMessage>
        <ButtonWrapper>
          <Button
            mainColor={main_color || false}
            aria-label={'Proceed to Payment'}
            onClick={onDone}
            fontSize="16px"
            padding="12px 24px"
          >
            {_('recycleRight.done')}
          </Button>
        </ButtonWrapper>
      </Wrapper>
    );
  }

  if (paymentStatus?.success && paymentStatus?.payment === 'failed') {
    return (
      <Wrapper>
        <ErrorMessage>Payment Failed!</ErrorMessage>
        <ButtonWrapper>
          <Button
            mainColor={main_color || false}
            aria-label={'Proceed to Payment'}
            onClick={onDone}
            fontSize="16px"
            padding="12px 24px"
          >
            {_('recycleRight.done')}
          </Button>
        </ButtonWrapper>
      </Wrapper>
    );
  }
};

export default connect((state) => ({
  mainColor: state.config.templateColour
    ? JSON.parse(state.config.templateColour)
    : {},
  bpData: state.bulkPickup.bpData
}), null)(Confirmation);

const OpacityAnimation = keyframes`
  from { opacity: 0;}
  to { opacity:1;}
`;

const TextHeader = styled.div`
  letter-spacing: 1px;
  cursor: pointer;
  font-size: 18px !important;
  color: rgb(64, 64, 64) !important;
  font-family: Roboto, sans-serif !important;
`;

const Container = styled.div`
  box-sizing: border-box;
  padding: 20px;
  border-radius: 10px;
  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 18px 0px;
  margin-top: 15px;
  margin-bottom: 35px;
  animation: ${OpacityAnimation} 0.5s;
`;

const Text = styled.span`
  font-size: 14px !important;
  color: #6C7293;
`;

const StyledText = styled(Text)`
  text-decoration: underline;
  font-style: italic;
  font-weight: bold;
`;

const Wrapper = styled.div`
  margin: 15px auto;
  max-width: 600px;
`;

const ErrorMessage = styled.div`
  padding: 30px;
  text-align: center;
`;

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 20px;
`;
